var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (value) {pug_mixins["entityName"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var isSearchTerm = item.typeName === 'SearchTerm';
var isAccount = item.typeName === 'Account';
var AccountActivityStatus = item.AccountActivityStatus;
if (isAccount) {
if (item.status === AccountActivityStatus.Errors) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"account-error-icon icon-error\""+pug.attr("title", item.i18n.getString('AccountStatus_Error'), true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
else
if (item.status === AccountActivityStatus.Deleted) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"account-deleted-icon\""+pug.attr("title", item.i18n.getString('AccountStatus_Deleted'), true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
else
if (item.status === AccountActivityStatus.Enabled) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"account-enabled-icon icon-success\""+pug.attr("title", item.i18n.getString('AccountStatus_Active'), true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
}
else
if (!isSearchTerm) {
pug_html = pug_html + "\u003Cdiv class=\"status\"\u003E";
if (item.status === 'Deleted') {
if (item.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-paused-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusDeleted_icon\"\u003E\u003C\u002Fdiv\u003E";
}
}
else
if (item.status === 'Paused') {
if (item.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-paused-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusPaused_icon\"\u003E\u003C\u002Fdiv\u003E";
}
}
else
if (item.status === 'Suspended') {
if (item.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-paused-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusSuspended_icon\"\u003E\u003C\u002Fdiv\u003E";
}
}
else
if (item.status === 'Draft') {
if (item.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-paused-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusDraft_icon\"\u003E\u003C\u002Fdiv\u003E";
}
}
else
if (item.status === 'Expired') {
pug_html = pug_html + "\u003Cdiv class=\"statushypendisplay\"\u003E\u003C\u002Fdiv\u003E";
}
else {
if (item.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-active-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusEnabled_icon\"\u003E\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Ca" + (pug.attr("href", item.hash, true, true)+pug.attr("title", item.hideToolTip ? '' : item.name, true, true)+pug.attr("aria-label", item.i18n.getString(`${item.rawStatus} {{entity}}`, {entity: item.name}), true, true)+pug.attr("data-campaignid", item.campaignId, true, true)+pug.attr("data-adgroupid", item.adGroupId, true, true)+pug.attr("data-accountid", item.accountId, true, true)+pug.attr("data-type", item.typeName, true, true)+pug.attr("data-text", item.text, true, true)+pug.attr("data-navigationLevel", item.navigationLevel, true, true)+pug.attr("data-campaigntype", item.campaignType, true, true)+pug.attr("data-rawstatus", item.rawStatus, true, true)+pug.attr("data-campaignName", item.campaignName, true, true)+pug.attr("data-adGoupName", item.adGroupName, true, true)+pug.attr("data-matchType", item.matchType, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (isAccount && item.status === 'Deleted') {
pug_html = pug_html + "\u003Cspan class=\"inactive\"\u003E" + (null == (pug_interp = `&nbsp(${item.i18n.getString('AccountStatus_InActive')})`) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
};
pug_html = pug_html + "\u003Cdiv class=\"grid-cell grid-cell--Name\"\u003E";
var hideToolTip = (value.typeName === 'Keyword') || (value.typeName === 'SearchTerm' && value.matchingKeyword);
var nameCell = {};
nameCell.status = value.Status;
nameCell.name = value.Name;
nameCell.hash = value.hash;
nameCell.campaignId = value.ids.campaignId;
nameCell.adGroupId = value.ids.adgroupId;
nameCell.accountId = value.ids.accountId;
nameCell.typeName = value.typeName;
nameCell.text = value.keywordText;
nameCell.navigationLevel = value.navigationLevel;
nameCell.campaignName = value.Campaign.Name;
nameCell.adGroupName = value.AdGroup.Name;
nameCell.matchType = value.MatchType;
nameCell.hideToolTip = hideToolTip;
nameCell.isExperiment = value.isExperiment;
nameCell.campaignType = value.campaignType;
nameCell.rawStatus = value.rawStatus;
nameCell.i18n = value.i18n;
nameCell.AccountActivityStatus = value.AccountActivityStatus;
pug_mixins["entityName"](nameCell);
if (value.typeName === 'SearchTerm') {
pug_html = pug_html + "\u003Cdiv class=\"search-term-detail\"\u003E\u003Cdiv class=\"actions\"\u003E";
if (value.matchingKeyword) {
var added = value.searchTermStatus.indexOf('Added') > -1;
if (added) {
pug_html = pug_html + "\u003Cdiv class=\"add\"\u003E" + (null == (pug_interp = value.i18n.getString('SearchTermStatus_Added')) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cbutton class=\"add\"\u003E\u003Cdiv class=\"glyphicon search-term-add-keyword\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E" + (null == (pug_interp = value.i18n.getString('Dashboard_TopSearchTerms_Add')) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fbutton\u003E";
}
}
var excluded = value.searchTermStatus.indexOf('Excluded') > -1;
if (excluded) {
pug_html = pug_html + "\u003Cdiv class=\"exclude\"\u003E" + (null == (pug_interp = value.i18n.getString('SearchTermStatus_Excluded')) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cbutton class=\"exclude\"\u003E\u003Cdiv class=\"glyphicon search-term-add-neg-keyword\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E" + (null == (pug_interp = value.i18n.getString('Dashboard_TopSearchTerms_Exclude')) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"grid-cell--Name__hover-container\"\u003E\u003Cdiv class=\"hover-content\"\u003E\u003Cdiv class=\"hover-content__text\"\u003E" + (pug.escape(null == (pug_interp = value.Name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"hover-content__content\"\u003E" + (pug.escape(null == (pug_interp = value.Name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (value.matchingKeyword) {
pug_html = pug_html + "\u003Cdiv class=\"hover-content__title\"\u003E" + (null == (pug_interp = value.i18n.getString('Dashboard_TopSearchTerms_Matched_Keyword')) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"hover-content__text\" style=\"padding-bottom:0px\"\u003E" + (null == (pug_interp = value.matchingKeyword) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"hover-content__content\"\u003E" + (null == (pug_interp = value.matchingKeyword) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
else
if (value.typeName === 'Keyword') {
pug_html = pug_html + "\u003Cdiv class=\"grid-cell--Name__hover-container\"\u003E\u003Cdiv class=\"hover-content\"\u003E\u003Cdiv class=\"hover-content__text\"\u003E" + (pug.escape(null == (pug_interp = value.Name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"hover-content__name\"\u003E\u003Cdiv class=\"name-value\"\u003E" + (pug.escape(null == (pug_interp = value.Campaign.Name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"name-value\"\u003E" + (null == (pug_interp = ' ') ? "" : pug_interp) + "\u003E " + (pug.escape(null == (pug_interp = value.AdGroup.Name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E" + (null == (pug_interp = value.i18n.getString('ColumnName_Type')) ? "" : pug_interp) + ": " + (null == (pug_interp = value.MatchType) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"hover-content__content\"\u003E" + (pug.escape(null == (pug_interp = value.Campaign.Name) ? "" : pug_interp)) + " \u003E " + (pug.escape(null == (pug_interp = value.AdGroup.Name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;